export default __webpack_public_path__ + "static/media/mniszek.5df0f7ac.svg";